<!-- <div class="header-wrapper d-flex justify-content-between">
  <img src="https://images.5paisa.com/forum/icon-left-arrow.svg" (click)="goBack()" />
  <h3 class="m-0 font-16 fw-500">Create Ticket</h3>
  <div class="header-image-wrapper"> -->
    <!-- <img src="https://images.5paisa.com/forum/icon-language.png" /> -->
  <!-- </div>
</div> -->

<div class="main-wrapper crete-ticket-form">
  <form [formGroup]="createTicketForm" novalidate>
  <mat-form-field floatLabel="always">
    <mat-label>CHOOSE PROBLEM CATEGORY</mat-label>
    <mat-select formControlName="category" (selectionChange)="selectFirstCategory($event.value)" placeholder="Select">
      <mat-option *ngFor="let item of mainBaseArray" [value]="item.name" (click)="showChild(item.name)" >{{item.name}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="showSecondaryCategory">
    <mat-label>SECONDARY CATEGORY</mat-label>
    <mat-select formControlName="subCategory" (selectionChange)="selectSecondCategory($event.value)" placeholder="Select">
      <mat-option *ngFor="let item of childArray" (click)="frequentlyAskedQuestions(item.id)" [value]="item.name">{{item.name}}</mat-option>
    </mat-select>
  </mat-form-field>
  
    <mat-form-field floatLabel="always">
      <mat-label>SUBJECT</mat-label>
      <input matInput formControlName="subject" placeholder="Please fill the subject">
    </mat-form-field>

    <!-- <h3>Couldn’t find help? continue with ticket!</h3> -->

    <mat-form-field floatLabel="always">
      <mat-label>DESCRIBE YOUR ISSUE IN DETAIL</mat-label>
      <textarea
        matInput
        placeholder="Please attach a screenshot/image to help answer you better."
        formControlName="issueDescription"
      ></textarea>
    </mat-form-field>
  </form>  

  <div class="upload-file">
    <div class="upload-wrapper">
      <img src="https://images.5paisa.com/forum/icon-upload.svg" alt="Upload Icon" title="Upload Icon" />

      <label class="custom-file-upload">
        <input type="file" #fileInput
          type="file"
          accept="image/jpg,
          image/jpeg,
          image/png,
          application/pdf,
          application/msword,
          application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          (change)="onFileSelected($event)"
        >
        <span *ngIf="isFileUploaded == false">
          Upload file
        </span>
        <span *ngIf="isFileUploaded == true">
          Upload new file
        </span>
    </label>
      <img src="https://images.5paisa.com/forum/icon-circle-check.svg" alt="Upload Icon" title="Upload Icon" *ngIf="isFileUploaded"/>      
    </div>
    <p *ngIf="fileSizeError" style="color: red;">File size Limit Exceeded</p>
    <p>Max file size: 5MB each</p>
    <p>Supported types: PNG, JPG, JPEG, PDF, DOC.</p>
  </div>

  <div class="faq-section" *ngIf="showFaq">
    <h1 class="main-heading font-18 font-500">Here are few FAQs that might help you</h1>
    <div class="accordian-wrapper">
      <ul *ngFor="let item of faqArray">
        <li (click)="goTosubCategoryAnswers(item.id, item.permalink, item.category.id)">
          <h2 class="label">{{item.title}}</h2>
          <span class="icon-right-chevron"></span>
        </li>
      </ul>
    </div>
    <div class="faq-text-wrapper">
      <a *ngIf="showMore" href="javascript:;" (click)="goToSubCategory()">View All FAQ's</a>
    </div>
  </div>
  
  <div class="bottom-button-wrapper">
    <button class="btn-primary" (click)="checkValidationAndCreateTicket()">Create ticket</button>
  </div>
</div>